import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type { AysCodeResponse } from '@bindoc-projects/code-domain-lib';
import { AysCode } from '@bindoc-projects/code-domain-lib';

export const BD_DRG_CODE_CONTENT_CONDITION_ID = 'drgCode';
export const FilterConditionDrgCodePluginType: FilterConditionPluginSpecification<
  AysCode[],
  FilterConditionDrgCodeDto,
  BdDrgCodeContentCondition
> = {
  type: 'drgCode',
  category: 'case',
  displayName: { de: 'DRG-Ziffer' },
  sortingIndex: 10,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionDrgCodeDto,
  ): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionDrgCodePlugin(
        obj.codes.map((it) => AysCode.fromObject(it)),
      );
  },
  fromCondition(
    jsonObj: BdDrgCodeContentCondition,
  ): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionDrgCodePlugin(
        (jsonObj.includes ?? []).map((it) => AysCode.fromObject(it)),
      );
  },
  newInstance(): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionDrgCodePlugin([]);
  },
};

export class FilterConditionDrgCodePlugin extends FilterConditionPluginImpl<
  AysCode[],
  FilterConditionDrgCodeDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysCode[],
    FilterConditionDrgCodeDto,
    BdDrgCodeContentCondition
  > = FilterConditionDrgCodePluginType;

  constructor(private codes: AysCode[]) {
    super(FilterConditionDrgCodePluginType.type);
  }

  clone(): FilterConditionDrgCodePlugin {
    return new FilterConditionDrgCodePlugin([
      ...this.codes.map((it) => it.clone()),
    ]);
  }

  override equals(other: FilterConditionDrgCodePlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.codes,
        other.codes,
        (a, b) => a.name === b.name && a.codingSystem === b.codingSystem,
      )
    );
  }

  override validationToText(): string {
    if (this.codes.length === 0) {
      return 'Mindestens eine DRG-Ziffer auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdDrgCodeContentCondition(this.codes, []);
  }

  toJSON(): FilterConditionDrgCodeDto | null {
    return {
      type: this.type,
      codes: this.codes,
    };
  }

  toText(): string | null {
    return 'DRG-Ziffer';
  }

  toValue(): AysCode[] {
    return this.codes;
  }
}

export class BdDrgCodeContentCondition extends BdContentCondition<AysCode> {
  constructor(includes: AysCode[], excludes: AysCode[]) {
    super(BD_DRG_CODE_CONTENT_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionDrgCodeDto {
  type: string;
  codes: AysCodeResponse[];
}
